module.exports = __webpack_public_path__ + "static/media/new_guide_image@2x.f84ee8fe.png";